import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ user, userPermissions, permission, children }) {
  if (!user) {
    return <Navigate to="/admin" replace />;
  }

  if (userPermissions[permission]) {
    return children;
  }

  // Redirect to a generic admin page or show an unauthorized message
  // You can create a specific unauthorized page if you want
  return <Navigate to="/admin" replace />;
}

export default ProtectedRoute;
